// extracted by mini-css-extract-plugin
export var filterIncDec = "_ed-0";
export var leftBorder = "_ed-1";
export var rightBorder = "_ed-2";
export var stringInput = "_ed-3";